export default __webpack_public_path__ + "assets/images/0d341746bd45c46e5d6b1c59901f5c56-email-icon.svg";